import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Popover} from "@mui/material";
import styled from "styled-components";
import {Text} from "../../../../../../common/text";
import SlateEditor from "../../../../../../Component/SlateEditor";
import {getTextCount} from "../../../../utils/getText";
import {THEME_SEMANTICS} from "../../../../../../common/theme/_semantics";
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";

export const LivestreamMessageConfirm = ({
    header,
    description,
    sample,
    validateMessage,
    onResetDefault,
    onChangeMessage,
    onBlurMessage,
    placeHolder,
    resetDefault,
    message,
    list: listProp,
    ...props
}) => {
    const {t} = useTranslation()
    const {data} = useFacebookMessageConfirmOrder()
    const {list: listFromLivestream} = data.livestreamDetail || {}
    const list = listProp ?? listFromLivestream ?? []
    return <StyledMessageConfirm>
        <div className='live-stream-message_notice_header'>
            <div style={{display:'flex', alignItems:'center', gap: 4}}>
                <Text fontSize={16} fontWeight={600}>
                    {t(header)}
                </Text>
                <TooltipSample
                    texts={sample?.texts}
                    tooltipTitle={'contentMessage'}
                />
            </div>
            <div onClick={onResetDefault} className='live-stream-message_notice_header-reset'>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M11.3333 6.82358H15V3M14.7868 13.2143C14.1034 14.3115 13.1007 15.1515 11.9259 15.6107C10.7511 16.07 9.46587 16.1244 8.25919 15.7659C7.05251 15.4075 5.98802 14.6553 5.22162 13.6194C4.45521 12.5835 4.02756 11.3186 4.00129 10.0105C3.97501 8.70244 4.35129 7.42006 5.07543 6.3516C5.79956 5.28314 6.83315 4.48508 8.02438 4.07426C9.21561 3.66345 10.5019 3.66147 11.6941 4.06904C12.8864 4.4766 13.922 5.27193 14.6488 6.33841" stroke="#1162FF" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <Text color={'#1162FF'}>
                    {t('reset')}
                </Text>
            </div>
        </div>
        <Text color={'#717483'}>{t(description)}</Text>
        <div className='live-stream-message_notice_body'>
            <div className='live-stream-message_notice_message'>
                <SlateEditor
                    maxLength={300}
                    initialValue={message}
                    message={message}
                    slateValue={{
                        listPopover: Array.isArray(list) ? list : [],
                        textCount: getTextCount(message).length,
                        placeHolder: t(placeHolder),
                        validate: validateMessage || '',
                        resetDefault,
                    }}
                    functionProps={{
                        onChange: onChangeMessage,
                        onBlurSlate: onBlurMessage,
                        onResetDefault
                    }}
                />
            </div>
        </div>
    </StyledMessageConfirm>
}

const TooltipSample = ({
                           id,
                           tooltipTitle,
                       })=>{
    const [anchorEl, setAnchorEl] = useState(null)
    const {t} = useTranslation()

    const handleClick = e => {
        e.preventDefault()
        e.stopPropagation()
        setAnchorEl(e.currentTarget)
    }

    const handleClose = () => setAnchorEl(null)

    const open = Boolean(anchorEl)
    const idData = open ? id : undefined
    return (
        <>
            <Text
                color={'#1162FF'}
                onClick={handleClick}
                style={{cursor:'pointer'}}
            >
                {t('see_sample')}
            </Text>
            {open &&  (
                <Popover
                    id={idData}
                    className="common-popover"
                    open={true}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <StyledRowMenuPopover onClick={handleClose}>
                        <Text color={'#ffffff'} fontWeight={600}>{t(tooltipTitle)}</Text>
                        <ul style={{marginTop: 12 , backgroundColor: '#ffffff', borderRadius: 8, padding: 12}}>
                            <li className="row-menu-popover__item">
                                <Text>
                                    ការបញ្ជាទិញរបស់អតិថិជនត្រូវបានដាក់ដោយជោគជ័យ។ លេខកូដបញ្ជាទិញគឺ៖ [លេខកូដបញ្ជាទិញ] ជាមួយនឹងផលិតផល៖ [ខ្លឹមសារមតិយោបល់]។ សូមអរគុណដែលបានបញ្ជាទិញនៅទំព័រ [ឈ្មោះទំព័រ]
                                </Text>
                            </li>
                        </ul>
                    </StyledRowMenuPopover>

                </Popover>
            )}
        </>
    )
}
const StyledRowMenuPopover = styled.div`
  width: 280px;
  padding: 12px;
  background-color: rgba(0, 31, 62, 0.95);
  .row-menu-popover {
    &__item {
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
`
const StyledMessageConfirm = styled.div`
  .live-stream-message_notice{
      &_header{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &_header-reset{
        width: fit-content;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      &_body{
        margin-top: 12px;
      }
      &_button{
        position: relative;
        .input__input{
          height: auto;
          padding: 16px;
          font-weight: 600 !important;
        } 
      }
      &_message-text{
        min-height: 114px;
        max-height: 200px;
      }
      &_message-editor{
        width: 100%;
        min-height: 114px;
        padding: 16px;
        font-family: "SF Pro Display";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        color: #00081D;
      }
      &_message-tag{
        cursor: pointer;
        width: fit-content;
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid #1162FF;
        color: #1162FF;
      }
      &_add-tag{
        border-top: 1px solid #ebeef5;
        padding: 8px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &_count{
        position: absolute;
        top: 56%;
        right: 3%;
      }
  }
`